import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Treatment, BookingFormData } from '../types/treatment';
import { fetchMassages, fetchYogatherapy } from '../services/treatmentApi';

export const useTreatmentStore = defineStore('treatment', () => {
  const massages = ref<Treatment[]>([]);
  const yogatherapy = ref<Treatment[]>([]);
  const isLoading = ref(false);
  const error = ref<string | null>(null);

  async function loadMassages() {
    try {
      isLoading.value = true;
      error.value = null;
      const data = await fetchMassages();
      massages.value = data || [];
    } catch (e) {
      error.value = 'Failed to load massages';
      massages.value = [];
    } finally {
      isLoading.value = false;
    }
  }

  async function loadYogatherapy() {
    try {
      isLoading.value = true;
      error.value = null;
      const data = await fetchYogatherapy();
      yogatherapy.value = data || [];
    } catch (e) {
      error.value = 'Failed to load yogatherapy sessions';
      yogatherapy.value = [];
    } finally {
      isLoading.value = false;
    }
  }

  async function bookMassage(data: BookingFormData) {
    // Mock implementation - would normally make an API call
    const newMassage: Treatment = {
      ...data,
      type: 'New Massage',
      room: 'TBD',
      status: 'pending'
    };
    massages.value.push(newMassage);
  }

  async function bookYogatherapy(data: BookingFormData) {
    // Mock implementation - would normally make an API call
    const newSession: Treatment = {
      ...data,
      type: 'New Session',
      room: 'TBD',
      status: 'pending'
    };
    yogatherapy.value.push(newSession);
  }

  return {
    massages,
    yogatherapy,
    isLoading,
    error,
    loadMassages,
    loadYogatherapy,
    bookMassage,
    bookYogatherapy
  };
});